import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { domain } from "../variables/domain";
import { map } from "rxjs/operators";
import { Subject } from "rxjs";
import { EncryptionService } from "./encryption.service";
import { SharedServices } from "./shared.service";

@Injectable({
  providedIn: "root",
})
export class LeadsService {
  private isUserChanged = new Subject<any>();
  private isTeamChanged = new Subject<any>();
  private isLeadSelected = new Subject<any>();
  private isTeamRemove = new Subject<any>();
  private isLeadAssign = new Subject<any>();
  private userLogoutLogin = new Subject<any>();
  constructor(
    private http: HttpClient,
    private encryptionService: EncryptionService,
    private sharedServices: SharedServices
  ) { }
  setUserChanged(value) {
    this.isUserChanged.next(value);
  }
  public get getUserChanged() {
    return this.isUserChanged.asObservable();
  }
  setTeamChanged(value) {
    this.isTeamChanged.next(value);
  }
  public get getTeamChanged() {
    return this.isTeamChanged.asObservable();
  }
  setTeamRemove(value) {
    this.isTeamRemove.next(value);
  }

  public get getTeamRemove() {
    return this.isTeamRemove.asObservable();
  }

  setLeadSelected(value) {
    this.isLeadSelected.next(value);
  }
  public get getLeadSelected() {
    return this.isLeadSelected.asObservable();
  }
  setuserLogoutLogin(value) {
    this.userLogoutLogin.next(value);
  }
  public get getuserLogoutLogin() {
    return this.userLogoutLogin.asObservable();
  }
  setLeadAssign(value) {
    this.isLeadAssign.next(value);
  }
  public get getLeadAssign() {
    return this.isLeadAssign.asObservable();
  }

  ValidateAgentUser(details) {
    return this.http
      .post(domain.ValidateAgentUser, details)
      .pipe(map((res: any) => res));
  }

  getLeadById(leadId) {
    return this.http
      .get(domain.getLeadById + leadId)
      .pipe(map((res: any) => res));
  }
  getMyLeads(filterObject) {
    return this.http
      .post(
        domain.getMyLeads, filterObject

      )
      .pipe(map((res: any) => res));
  }
  addLead(details) {
    return this.http.post(domain.addLead, details).pipe(map((res: any) => res));
  }
  UpdateLead(details) {
    return this.http
      .post(domain.UpdateLead, details)
      .pipe(map((res: any) => res));
  }

  AddAgentUser(details) {
    return this.http
      .post(domain.AddAgentUser, details)
      .pipe(map((res: any) => res));
  }
  UpdateAgentUser(details) {
    return this.http
      .post(domain.UpdateAgentUser, details)
      .pipe(map((res: any) => res));
  }
  DeleteAgentUser(Id) {
    return this.http
      .post(domain.DeleteAgentUser + Id, {})
      .pipe(map((res: any) => res));
  }
  AddTeam(details) {
    return this.http.post(domain.AddTeam, details).pipe(map((res: any) => res));
  }
  UpdateTeam(details) {
    return this.http
      .post(domain.UpdateTeam, details)
      .pipe(map((res: any) => res));
  }
  GetAgentUserById(Id) {
    return this.http
      .get(domain.GetAgentUserById + Id)
      .pipe(map((res: any) => res));
  }
  GetAgentUserList(userRoleId, mainAgentId) {
    return this.http
      .get(
        domain.GetAgentUserList +
        "userRoleId=" +
        userRoleId +
        "&mainAgentId=" +
        mainAgentId
      )
      .pipe(map((res: any) => res));
  }
  GetTeamList(mainAgentId, adminId) {
    return this.http
      .get(domain.GetTeamList + "mainAgentId=" + mainAgentId)
      .pipe(map((res: any) => res));
  }
  GetTeamDetails(Id) {
    return this.http
      .get(domain.GetTeamDetails + Id)
      .pipe(map((res: any) => res));
  }

  DeleteTeam(Id) {
    return this.http
      .post(domain.DeleteTeam + Id, {})
      .pipe(map((res: any) => res));
  }
  DeleteLead(Id) {
    return this.http
      .post(domain.deleteLead + Id, {})
      .pipe(map((res: any) => res));
  }
  AssignLead(details) {
    return this.http
      .post(domain.assignLead, details)
      .pipe(map((res: any) => res));
  }
  EditManager(leadId, Id) {
    return this.http
      .post(domain.EditManager + "leadId=" + leadId + "&managerId=" + Id, {})
      .pipe(map((res: any) => res));
  }
  EditAdmin(leadId, Id) {
    return this.http
      .post(domain.EditAdmin + "leadId=" + leadId + "&adminId=" + Id, {})
      .pipe(map((res: any) => res));
  }
  EditLeader(leadId, Id) {
    return this.http
      .post(domain.EditLeader + "leadId=" + leadId + "&leaderId=" + Id, {})
      .pipe(map((res: any) => res));
  }
  EditTeam(leadId, detail) {
    return this.http
      .post(domain.EditTeam + "leadId=" + leadId, { TeamIds: detail })
      .pipe(map((res: any) => res));
  }
  EditEmployee(leadId, detail) {
    return this.http
      .post(domain.EditEmployee + "leadId=" + leadId, { employeeIds: detail })
      .pipe(map((res: any) => res));
  }
  AddLeadHistory(LeadId, HistoryType, Message) {
    let leadHistoryObject: any = {
      LeadId: LeadId,
      AgentUserId: 0,
      MainAgentId: this.sharedServices.getAgentId(),
      HistoryType: HistoryType,
      Message: Message,
    };

    if (this.sharedServices.isAgent()) {
      leadHistoryObject.AgentUserId = 0;
    } else {
      leadHistoryObject.AgentUserId = this.sharedServices.getAgentUserId();
    }
    return this.http
      .post(domain.AddLeadHistory, leadHistoryObject)
      .pipe(map((res: any) => res));
  }
  GetLeadHistoryByLeadId(leadId) {
    return this.http
      .get(domain.GetLeadHistoryByLeadId + "leadId=" + leadId)
      .pipe(map((res: any) => res));
  }
  GetLeadActivityHistory(leadId) {
    return this.http
      .get(
        domain.GetLeadActivityHistory +
        "PropertyId=" +
        leadId +
        "&UserId=" +
        this.sharedServices.getAgentId()
      )
      .pipe(map((res: any) => res));
  }
  RemoveTeamFromLead(details) {
    return this.http
      .post(domain.RemoveTeamFromLead, details)
      .pipe(map((res: any) => res));
  }
  ImportAgentProperty(details,isActive) {
    return this.http
      .post(domain.ImportAgentProperty, details,isActive)
      .pipe(map((res: any) => res));
  }
  ImportLeadProperty(details) {
    return this.http
      .post(domain.ImportLeadProperty, details)
      .pipe(map((res: any) => res));
  }
  ExportCallingResponseData(details: any) {
    return this.http.post(domain.ExportCallingResponseData, details, {
      responseType: 'blob',
      observe: 'response'
    });
  }

  ExportCallingLeads(details: any) {
    return this.http.post(domain.ExportCallingLeads, details, {
      responseType: 'blob',
      observe: 'response'
    });
  }
  DownloadFile(fileName) {
    return this.http
      .get(domain.DownloadFile + fileName)
      .pipe(map((res: any) => res));
  }
  SearchLeadbyNumber(mobileNo) {
    return this.http
      .get(domain.SearchLeadbyNumber + 'userId=' + this.sharedServices.getAgentId() + '&mobileNo=' + mobileNo)
      .pipe(map((res: any) => res));
  }
  ExportMyLeads() {
    return this.http.post(domain.ExportMyLeads, { 'MainAgentId': this.sharedServices.getAgentId() }, {
      responseType: 'blob',
      observe: 'response'
    });
  }
  ExportAgentProperty(details) {
    return this.http.post(domain.ExportAgentProperty, details, {
      responseType: 'blob',
      observe: 'response'
    });
  }
}
